// src/pages/dashboard/DraftsPage.jsx
import React from 'react';

const DraftsPage = () => {
  return <h1 className="text-2xl font-bold">Mes brouillons</h1>;
};

export default DraftsPage;
